import Skeleton from "@/v2-ui/skeleton"
import StatusSection from "@/v2-status-client/status/section/StatusSection"

// Incidents-section skeleton. Two day-groups, two rows each, so
// the placeholder reads as a real timeline rather than a single
// cluster. The badge / title / meta layout matches
// `StatusIncidentRow` so when the data lands the row alignment
// stays put. Empty list is also a valid live state ("no
// incidents in the last 30 days") -- we never render the
// skeleton there, only on the very first poll, so the few
// hundred ms of pulsing-then-empty isn't worth special-casing.
function StatusIncidentListSkeleton() {
  return (
    <StatusSection
      title="Recent incidents"
      aside="last 30 days"
      aria-busy="true"
    >
      <ol aria-hidden className="flex flex-col gap-3 list-none m-0 p-0 pl-4">
        {DAY_GROUPS.map((group, gi) => (
          <li
            key={gi}
            className="flex flex-col gap-1.5 border-b border-border/60 pb-3 last:border-b-0 last:pb-0"
          >
            <Skeleton className="h-3 w-32" />
            <ul className="flex flex-col list-none p-0 m-0">
              {group.rows.map((titleWidth, ri) => (
                <li key={ri} className="flex items-start gap-3 py-2">
                  <Skeleton className="mt-0.5 h-4 w-16 rounded-full" />
                  <div className="flex min-w-0 flex-1 flex-col gap-1">
                    <Skeleton className={`h-4 ${titleWidth}`} />
                    <Skeleton className="h-3 w-3/4 max-w-md" />
                  </div>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </StatusSection>
  )
}

const DAY_GROUPS = [
  { rows: ["w-3/4", "w-2/3"] },
  { rows: ["w-2/3", "w-1/2", "w-3/5"] },
] as const

export default StatusIncidentListSkeleton
